import React, { useState, useEffect } from 'react';
import './Body.css';
import { Container, Col, Row } from "react-bootstrap";
const PageContent = () => {
  const [data, setData] = useState(null);
  const jsonUrl = process.env.REACT_APP_CDN_IMAGES + "static_celligence_JSON.json"; // Fetching the CDN URL from the environment variable
const imgCDNURL = process.env.REACT_APP_CDN_IMAGES
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch( jsonUrl);
        if (!response.ok) {
          throw new Error("Failed to fetch JSON data");
        }
     
        const jsonData = await response.json();
       
        setData(jsonData.pageContent[0]); 
      } catch (error) {
        console.error("Error fetching JSON data:", error);
      }
    };

    fetchData();
  }, [jsonUrl]);

  if (!data) return <div>Loading...</div>;

  return (
    <Container>
    <div className="page-content">
      <h2 className="page-title">{data.title}</h2>
      <h1 className="highlighted-text">{data.highlightedText}<span className='highlight-text'> {data.highlightedText2}</span></h1>
      <p className="subtitle">{data.subtitle}</p>
      <Row>
    <Col lg={2}></Col>
    <Col  className="get-in-touch-col" lg={8}>
      <div className="get-in-touch">
        <div className="get-in-touch-div">
        <h1>{data.getInTouchHeading}</h1>
        </div>
        <p>{data.notice}</p>
        <p>{data.assistanceText}</p>
        <div className="contact-info">
            <div className='d-flex'>
              <img src={imgCDNURL + "ph-icon.webp"} alt='phone icon'/>
              <p><a href={`tel:${data.contact.phone}`}>{data.contact.phone}</a></p>
            </div>
            <div className='email d-flex'>
            <img src={imgCDNURL + "em-icon.webp"} alt='email icon'/>
            <p><a href={`mailto:${data.contact.email}`}>{data.contact.email}</a></p>
            </div>
        </div>
      </div>
      </Col>
      <Col lg={2}></Col>
      </Row>
    </div>
    </Container>
  );
};

export default PageContent;
